export const ACCESS_TOKEN_KEY = Symbol('ACCESS_TOKEN_KEY');
export const REFRESH_TOKEN_KEY = Symbol('REFRESH_TOKEN_KEY');
export const ACCOUNT_MANAGER_DEAL_SESSION_KEY = Symbol(
  'ACCOUNT_MANAGER_DEAL_SESSION_KEY'
);
export const HUBSPOT_ID_KEY = Symbol('HUBSPOT_ID_KEY');
export const APPLY_DATA = Symbol('APPLY_DATA');
